// project imports
import App from 'App';
import globalState from 'app/context/globalState';
// style + assets
import 'assets/scss/style.scss';
import i18next from 'config/i18n';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
// third party
import { HashRouter } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
	<I18nextProvider i18n={i18next}>
		<Provider store={globalState.getStore()}>
			<HelmetProvider>
				<HashRouter>
					<App />
				</HashRouter>
			</HelmetProvider>
		</Provider>
	</I18nextProvider>,
	document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
